export default __webpack_public_path__ + "4657fa5390ef0133624f9bfabfc183a0.png";